// Публикация лошади живёт 30 дней, после чего крон на бэкенде переводит её в архив.
// Неполный день считаем оставшимся, поэтому округляем вверх.
export const getHorseDaysLeft = (published_until?: string): number | null => {
  if (!published_until) return null

  const left = new Date(published_until).getTime() - Date.now()

  if (isNaN(left)) return null

  return Math.max(0, Math.ceil(left / (24 * 60 * 60 * 1000)))
}
